import React, { Component } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import './normalize.css';
import './App.css';
import ChooseLesson from '../ChooseLesson/ChooseLesson';

class App extends Component {
  render() {
  return(
    <div>
    <Router>
      <Switch>
      <Route exact path="/" component={ChooseLesson}/>
      </Switch>
    </Router>
  </div>
  )
  
  }
}

export default App;
